document.addEventListener("DOMContentLoaded", () => {
  const featuredProductSections = document.querySelectorAll('.featured-product__main');

  featuredProductSections.forEach((featuredProduct) => {
    const koalaBundle = featuredProduct.querySelector('koala-bundle-block');
    if (!koalaBundle) return;

    const priceItem = featuredProduct.querySelector('.price-item');
    const koalaTotalPrice = featuredProduct.querySelector('.koala-deal__bundle-total__price');

    if (priceItem && koalaTotalPrice) {
      koalaTotalPrice.innerText = priceItem.innerText.trim();
    }

    const bundleButton = featuredProduct.querySelector('.koala-deal__bundle-action__button');
    const submitFormButton = featuredProduct.querySelector('button.product-form__submit');

    if (!bundleButton || !submitFormButton) return;

    bundleButton.setAttribute('type', 'button');

    bundleButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      submitFormButton.click();
      return false;
    }, true);
  });
});

document.addEventListener("DOMContentLoaded", () => {
  function initPDPBundle() {
    const productSections = document.querySelectorAll('.product, .product__info-wrapper');

    productSections.forEach((product) => {
      const koalaBundle = product.querySelector('koala-bundle-block');
      if (!koalaBundle) return;

      const priceItem = product.querySelector('.price-item');
      const koalaTotalPrice = product.querySelector('.koala-deal__bundle-total__price');

      if (priceItem && koalaTotalPrice) {
        koalaTotalPrice.innerText = priceItem.innerText.trim();
      }

      const bundleButton = product.querySelector('.koala-deal__bundle-action__button');
      const submitFormButton = product.querySelector('button.product-form__submit');

      if (!bundleButton || !submitFormButton) return;

      bundleButton.setAttribute('type', 'button');

      // evita múltiplos bindings
      if (bundleButton.dataset.bound === 'true') return;
      bundleButton.dataset.bound = 'true';

      bundleButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        submitFormButton.click();
        return false;
      }, true);
    });
  }

  initPDPBundle();
});